<script>
    import has from 'lodash/has';
    import { mapActions } from 'vuex';
    import Cookie from '@/services/cookie';
    import store from '@/apps/dashboard/store';

    export default {
        data() {
            return {
                loaded: false,
            };
        },

        methods: {
            ...mapActions('auth', {
                $_authLogin: 'login',
                $_authRegister: 'register',
            }),

            ...mapActions('me', {
                $_storeUser: 'storeAllUserData',
                $_authenticated: 'authenticated',
            }),

            $_login(data) {
                const loginData = {
                    email: data.email,
                    password: data.password,
                    token: data.token,
                };

                return this.$_authLogin(loginData).then(response => {
                    this.$_storeUserAfterLogin(response);
                    this.$emit('afterLogin');
                    return response;
                });
            },

            $_register(data) {
                if (!has(data, 'channel_source')) {
                    data.channel_source = 'applyflow';
                }

                return this.$_authRegister(data).then(response => {
                    this.$_storeUserAfterRegister(response);
                    return response;
                });
            },

            $_storeUserAfterRegister(data) {
                this.$_storeUser(data.data);
                Cookie.setToken(data.access_token);
            },

            $_storeUserAfterLogin(data) {
                this.$_storeUser(data.data);
                Cookie.setToken(data.access_token);
            },

            async $_redirectIfAuthenticated() {
                const token = Cookie.getToken();
                const redirectToDash = '/user-dashboard';

                let redirect = false;

                if (token) {
                    if (store?.state?.user?.id) {
                        redirect = true;
                    } else {
                        await this.$_authenticated();
                        if (Cookie.getToken()) {
                            redirect = true;
                        }
                    }
                }

                if (redirect) {
                    Cookie.deleteOauthInfo();
                    window.location.href = redirectToDash;
                } else {
                    this.loaded = true;
                }
            },
        },
    };
</script>
